import type { EntityType } from "@/lib/brokerAccounts";

/** Every legal entity type the account contract accepts, with its label. One
 *  list for every surface that shows or edits it. */
export const ENTITY_TYPE_LABELS: Record<EntityType, string> = {
  sole_proprietorship: "Sole proprietorship",
  partnership: "Partnership",
  llc: "LLC",
  llp: "LLP",
  c_corporation: "C corporation",
  s_corporation: "S corporation",
  trust: "Trust",
  joint_venture: "Joint venture",
  not_for_profit: "Not-for-profit",
  unincorporated_association: "Unincorporated association",
};

export const ENTITY_TYPE_OPTIONS = (
  Object.keys(ENTITY_TYPE_LABELS) as EntityType[]
).map((value) => ({ value, label: ENTITY_TYPE_LABELS[value] }));
